module.exports = __webpack_public_path__ + "assets/feedbackicon-5.de560cd9.svg";